import { Entity } from "api"

const isRootEntity = ({ id, parentId }: Entity): boolean => id === parentId

export { isRootEntity }
